import styles from './widget-loader-spinner.module.scss';

const WidgetLoadingSpinner = () => {
  return <span className={styles.loader} />;
};

export default WidgetLoadingSpinner;
